import { graphql } from "@/graphql/generated/gql";

export const getIndicatorQueryDocument = graphql(/* GraphQL */ `
  query GetIndicator($input: GetIndicatorInput!) {
    indicator(getIndicatorInput: $input) {
      ...IndicatorFields
      indicatorInstanceList {
        ...IndicatorInstanceFields
      }
    }
  }
`);

export const getIndicatorListQueryDocument = graphql(/* GraphQL */ `
  query GetIndicatorList($input: GetIndicatorListInput!) {
    indicatorList(getIndicatorListInput: $input) {
      ...IndicatorFields
      indicatorInstanceList {
        ...IndicatorInstanceFields
      }
    }
  }
`);

export const getIndicatorListByOwnerIdQueryDocument = graphql(/* GraphQL */ `
  query GetIndicatorListByOwnerId($input: GetIndicatorListByOwnerIdInput!) {
    indicatorListByOwner(getIndicatorListByOwnerIdInput: $input) {
      ...IndicatorFields
      indicatorInstanceList {
        ...IndicatorInstanceFields
      }
    }
  }
`);

export const createIndicatorMutationDocument = graphql(/* GraphQL */ `
  mutation CreateIndicator($input: CreateIndicatorInput!) {
    createIndicator(createIndicatorInput: $input) {
      ...IndicatorFields
      indicatorInstanceList {
        ...IndicatorInstanceFields
      }
    }
  }
`);

export const updateIndicatorMutationDocument = graphql(/* GraphQL */ `
  mutation UpdateIndicator($input: UpdateIndicatorInput!) {
    updateIndicator(updateIndicatorInput: $input) {
      ...IndicatorFields
      indicatorInstanceList {
        ...IndicatorInstanceFields
      }
    }
  }
`);

export const deleteIndicatorMutationDocument = graphql(/* GraphQL */ `
  mutation DeleteIndicator($input: DeleteIndicatorInput!) {
    deleteIndicator(deleteIndicatorInput: $input) {
      ...IndicatorFields
      indicatorInstanceList {
        ...IndicatorInstanceFields
      }
    }
  }
`);

export const createIndicatorValueMutationDocument = graphql(/* GraphQL */ `
  mutation CreateIndicatorValue($input: CreateIndicatorValueInput!) {
    createIndicatorValue(createIndicatorValueInput: $input) {
      ...IndicatorValueFields
    }
  }
`);

export const createIndicatorValueListMutationDocument = graphql(/* GraphQL */ `
  mutation CreateIndicatorValueList($input: CreateIndicatorValueListInput!) {
    createIndicatorValueList(createIndicatorValueListInput: $input) {
      ...IndicatorValueFields
    }
  }
`);

export const updateIndicatorValueMutationDocument = graphql(/* GraphQL */ `
  mutation UpdateIndicatorValue($input: UpdateIndicatorValueInput!) {
    updateIndicatorValue(updateIndicatorValueInput: $input) {
      ...IndicatorValueFields
    }
  }
`);

export const deleteIndicatorValueMutationDocument = graphql(/* GraphQL */ `
  mutation DeleteIndicatorValue($input: DeleteIndicatorValueInput!) {
    deleteIndicatorValue(deleteIndicatorValueInput: $input) {
      ...IndicatorValueFields
    }
  }
`);

export const createIndicatorInstanceMutationDocument = graphql(/* GraphQL */ `
  mutation CreateIndicatorInstance($input: CreateIndicatorInstanceInput!) {
    createIndicatorInstance(createIndicatorInstanceInput: $input) {
      ...IndicatorInstanceFields
    }
  }
`);

export const deleteIndicatorInstanceMutationDocument = graphql(/* GraphQL */ `
  mutation DeleteIndicatorInstance($input: DeleteIndicatorInstanceInput!) {
    deleteIndicatorInstance(deleteIndicatorInstanceInput: $input) {
      ...IndicatorInstanceFields
    }
  }
`);
